import { render } from "./QuickReference.vue?vue&type=template&id=62080577"
import script from "./QuickReference.vue?vue&type=script&lang=js"
export * from "./QuickReference.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__